import React from 'react';
import moment from 'moment';
import { getUser, invoke } from '../../../AppServices';
import { Form } from '../../../app-components/form/Form';
import { Toast } from '../../../app-components';
import { autoSuggestOptionsInput } from '../../../autoSuggestions';
import {
  selectActiveOrInactiveStatus,
  selectPaymentStatus,
} from '../../../Lib/constants';
import { EditDealerURI } from '../../../Queries/dealer';

export const checkExpiry = (value) => {
  const expiryDate = moment(value);
  const today = moment().utc();
  const difference = expiryDate.diff(today, 'days');

  if (difference < 0) {
    return 'Expired';
  }

  return '';
};

const handleSubmit = async (data, forInvoke, navigation, user) => {
  const {
    activityStatus,
    name,
    phonenumber,
    email,
    expire,
    paymentStatus,
    username,
  } = data;
  const toPass = {};
  toPass.paymentMode = forInvoke.paymentMode;
  toPass.dealerId = forInvoke.dealerId;

  if (user?.role?.code === 'superadmin') {
    toPass.name = name;
    toPass.phonenumber = phonenumber;
    toPass.email = email;
    toPass.username = username;
  }

  if (forInvoke.paymentMode === 'CASH') {
    toPass.paymentStatus = paymentStatus;
    if (paymentStatus === 'Complete' && checkExpiry(expire) === 'Expired') {
      toPass.expire = moment().add(30, 'days');
    }
  } else {
    toPass.activityStatus = activityStatus;
  }

  await invoke({ id: 'dealerStatusUpdate', paramValue: toPass });

  Toast.show({
    message: 'Success',
    description: 'Successfully Updated Dealer Details',
    type: 'success',
    position: 'top',
    direction: 'left',
  });
  navigation.pop();
};

const EditDealer = (props) => {
  const { navigation } = props;
  const arr = [];
  let mandatoryObj = {};
  const {
    paymentMode, paymentStatus, activityStatus, _id,
  } = navigation?.state?.params?.item;

  const forInvoke = {
    activityStatus,
    paymentMode,
    dealerId: _id,
    paymentStatus,
  };

  const user = getUser();

  arr.push({
    type: 'text',
    field: 'name',
    label: 'Dealership Name',
    mandatory: true,
    allowWhiteSpaces: true,
    editable: user?.role?.code === 'superadmin',
  });

  arr.push({
    type: 'text',
    field: 'username',
    label: 'Username',
    mandatory: true,
    allowWhiteSpaces: true,
    editable: false,
  });

  arr.push({
    type: 'text',
    field: 'phonenumber',
    label: 'Mobile Number',
    editable: user?.role?.code === 'superadmin',
  });

  arr.push({
    type: 'text',
    field: 'email',
    label: 'Email Id',
    mandatory: true,
    allowWhiteSpaces: false,
    editable: user?.role?.code === 'superadmin',
  });

  arr.push({
    type: 'date',
    field: 'expire',
    label: 'Expiry Date',
    mandatory: true,
    editable: false,
  });

  if (paymentMode === 'CASH') {
    mandatoryObj = { paymentStatus: 1 };
    arr.push(
      autoSuggestOptionsInput({
        label: 'Payment Status',
        field: 'paymentStatus',
        suggestionField: 'label',
        valueField: 'label',
        options: selectPaymentStatus,
        keyField: 'label',
      }),
    );
  } else if (paymentMode === 'CC') {
    mandatoryObj = { activityStatus: 1 };
    arr.push(
      autoSuggestOptionsInput({
        label: 'Activity Status',
        field: 'activityStatus',
        suggestionField: 'label',
        valueField: 'label',
        options: selectActiveOrInactiveStatus,
        keyField: 'label',
      }),
    );
  }



  return (
    <Form
      type="standard"
      uri={EditDealerURI}
      onSubmit={({ data }) => {
        handleSubmit({ ...data }, forInvoke, navigation, user);
      }}
      mandatory={mandatoryObj}
      fieldContainer="topLabel"
      lg={{
        formGroups: [
          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            groups: [
              {
                columns: arr,
              },
            ],
          },
        ],
      }}
      {...props}
    />
  );
};

export default EditDealer;
